import React from 'react';
import { colors } from '@styles/theme-chakra';

export default function Star({ size = 46, topColor = colors.primary }) {
  return (
    <svg width={size} height={size} viewBox="0 0 46 46" fill="none">
      <path
        d="M41.4333 18.3438L27.8922 17.1762L22.6 4.7085L17.3078 17.195L3.76666 18.3438L14.0497 27.252L10.961 40.4918L22.6 33.467L34.239 40.4918L31.1692 27.252L41.4333 18.3438Z"
        fill={colors.primary}
      />
    </svg>
  );
}
